if (!customElements.get('am-sticky-atc')) {
  customElements.define('am-sticky-atc', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.section = this.closest('.shopify-section');
      this.hidden = false;
      const signal = this.controller.signal;
      const scheduleUpdate = () => {
        if (this.updateFrame) return;
        this.updateFrame = requestAnimationFrame(() => {
          this.updateFrame = null;
          this.update();
        });
      };
      this.addEventListener('click', event => {
        if (event.target.closest('.am-sticky__options')) {
          const panel = this.querySelector('.am-sticky__panel');
          panel.hidden = !panel.hidden;
          this.querySelector('.am-sticky__options').setAttribute('aria-expanded', String(!panel.hidden));
          if (!panel.hidden) this.querySelector('.am-sticky__close')?.focus({preventScroll:true});
        } else if (event.target.closest('.am-sticky__close')) {
          this.closePanel(true);
        } else if (event.target.closest('.am-sticky__add')) {
          this.closePanel();
          this.original?.click();
        }
      }, {signal});
      this.addEventListener('change', event => {
        const select = event.target.closest('select[data-option-position]');
        if (!select || this.pending) return;
        const picker = this.section.querySelector('variant-picker[form-id="' + this.dataset.form + '"]');
        const input = Array.from(picker?.querySelectorAll('input[data-option-position]') || []).find(input => input.dataset.optionPosition === select.dataset.optionPosition && input.value === select.value);
        if (!input) return;
        this.pending = true;
        this.querySelector('.am-sticky__add').disabled = true;
        this.querySelectorAll('select').forEach(field => {field.disabled = true;});
        clearTimeout(this.pendingTimer);
        this.pendingTimer = setTimeout(() => {
          this.pending = false;
          this.snapshot = null;
          this.update();
        }, 12000);
        input.click();
      }, {signal});
      document.addEventListener('click', event => {if (!this.contains(event.target)) this.closePanel();}, {signal});
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !this.querySelector('.am-sticky__panel')?.hidden) this.closePanel(true);
      }, {signal});
      window.addEventListener('scroll', scheduleUpdate, {passive:true, signal});
      window.addEventListener('resize', scheduleUpdate, {passive:true, signal});
      this.contentObserver = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) scheduleUpdate();
      });
      this.contentObserver.observe(this.section, {subtree:true,childList:true});
      this.overlayObserver = new MutationObserver(scheduleUpdate);
      this.overlayObserver.observe(document.body, {subtree:true,attributes:true,attributeFilter:['open']});
      this.update();
    }
    syncSnapshot() {
      const source = document.getElementById(this.dataset.source);
      if (!source || source === this.snapshot) return;
      this.snapshot = source;
      this.pending = false;
      clearTimeout(this.pendingTimer);
      for (const selector of ['.am-sticky__title', '.am-sticky__price', '.am-sticky__options span', '.am-sticky__add span']) {
        const next = source.content.querySelector(selector);
        const current = this.querySelector(selector);
        if (next && current && current.textContent !== next.textContent) current.textContent = next.textContent;
      }
      const nextImage = source.content.querySelector('.am-sticky__image');
      const image = this.querySelector('.am-sticky__image');
      if (nextImage && image) {
        for (const attribute of ['src', 'srcset', 'sizes', 'width', 'height', 'alt']) {
          const value = nextImage.getAttribute(attribute);
          if (value !== null && image.getAttribute(attribute) !== value) image.setAttribute(attribute, value);
        }
      }
      this.querySelectorAll('select[data-option-position]').forEach(select => {
        const next = source.content.querySelector('select[data-option-position="' + select.dataset.optionPosition + '"]');
        if (next) {
          if (select.innerHTML !== next.innerHTML) select.innerHTML = next.innerHTML;
          select.value = next.value;
        }
        select.disabled = false;
      });
    }
    update() {
      this.syncSnapshot();
      const form = document.getElementById(this.dataset.form);
      const original = form?.querySelector('button[type="submit"]');
      if (original !== this.original) {
        this.attributesObserver?.disconnect();
        this.original = original;
        if (original) {
          this.attributesObserver = new MutationObserver(() => this.update());
          this.attributesObserver.observe(original, {attributes:true,attributeFilter:['disabled','aria-disabled','aria-busy']});
        }
      }
      if (!original) {
        this.querySelector('.am-sticky__add').disabled = true;
        return;
      }
      const rect = original.getBoundingClientRect();
      const headerRect = document.querySelector('.shopify-section--header')?.getBoundingClientRect();
      const visibleTop = headerRect && headerRect.top <= 1 && headerRect.bottom > 0 ? headerRect.bottom : 0;
      const overlay = document.querySelector('cart-drawer[open],quick-buy-modal[open],x-modal[open],x-drawer[open],dialog[open],.upcart-popup-show');
      const visible = rect.top <= visibleTop + 1 && rect.width > 0 && !overlay;
      this.toggleAttribute('data-visible', visible);
      this.inert = !visible;
      if (!visible) this.closePanel();
      const button = this.querySelector('.am-sticky__add');
      button.disabled = !!this.pending || original.disabled || original.getAttribute('aria-disabled') === 'true';
      button.setAttribute('aria-busy', String(!!this.pending || original.getAttribute('aria-busy') === 'true'));
    }
    closePanel(restoreFocus = false) {
      const panel = this.querySelector('.am-sticky__panel');
      if (panel) panel.hidden = true;
      const toggle = this.querySelector('.am-sticky__options');
      toggle?.setAttribute('aria-expanded', 'false');
      if (restoreFocus) toggle?.focus({preventScroll:true});
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
      clearTimeout(this.pendingTimer);
      this.attributesObserver?.disconnect();
      this.contentObserver?.disconnect();
      this.overlayObserver?.disconnect();
    }
  });
}
